import { HttpClient } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { environment } from "src/environments/environment";
import { User } from "src/model/class/general classes/user";
import {
  environmentDeviceLoadInitStartAction,
  environmentLoadInitStartAction,
} from "src/state/actions/environment.actions";
import { AppSettings } from "../components/shared-components/class/general-classes/app-settings";

@Injectable({
  providedIn: "root",
})
export class PermissionService implements OnDestroy {
  constructor(private _http: HttpClient, private _store: Store) { }

  /** Destroy event service */
  ngOnDestroy() { }

  /**
   *  Initialize public observable list trasmission: it should be call in the costructor of all component/page that you need.
   */
  public Init(): void { }

  /**
   * Get user environments
   * @param idEnvironment
   * @returns
   */
  public async getUserEnvironment(idEnvironment: number): Promise<User[]> {
    return this._http
      .get<Array<User>>(
        environment.httpServerRoot +
        AppSettings.API_URL_PERMISSION +
        "/userEnvironments/" +
        idEnvironment
      )
      .toPromise();
  }

  /**
   * Insert user environment permission
   * @param idEnvironment
   * @param idUser
   */
  public async handlePermissionUserEnvironment(
    idEnvironment: number,
    idUser: number,
    permission: boolean
  ): Promise<Object> {
    return this._http
      .post(
        environment.httpServerRoot +
        AppSettings.API_URL_PERMISSION +
        "/environment/" +
        idEnvironment +
        "/user/" +
        idUser,
        {
          permission: Number(permission),
        }
      )
      .toPromise();
  }

  /**
   * Removed user environment permission
   * @param idEnvironment
   * @param idUser
   * @returns
   */
  public async removeUserEnvironment(idEnvironment: number, idUser: number): Promise<Object> {
    return this._http
      .delete(
        environment.httpServerRoot +
        AppSettings.API_URL_PERMISSION +
        "/environment/" +
        idEnvironment +
        "/user/" +
        idUser
      )
      .toPromise();
  }

  /**
   * Insert usergroups environment permission
   * @param idEnvironment
   * @param idUserGroups
   */
  public async handlePermissionUserGroupsEnvironment(
    idEnvironment: number,
    idUserGroups: number,
    permission: boolean
  ): Promise<Object> {
    return this._http
      .post(
        environment.httpServerRoot +
        AppSettings.API_URL_PERMISSION +
        "/environment/" +
        idEnvironment +
        "/usergroup/" +
        idUserGroups,
        {
          permission: Number(permission),
        }
      )
      .toPromise();
  }
}
